import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { up } from "styled-breakpoints";


const IconContainer = styled.div`
    position: relative;
`;

const IconWrap = styled.div`
    ::before {
        content: '';
        position: absolute;
        bottom: -1.6em;
        left: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid black;
    
        ${up('md')} {
            bottom: -2.2em;
        }

        ${up('lg')} {
            bottom: -2em;
        }
    }
`;

const IconNavItem = props => {
    if (props.active) {
        return (
            <IconContainer>
                <IconWrap>
                    <FontAwesomeIcon 
                        style={{marginRight: '15px'}} 
                        size='2x' icon={props.icon} 
                        color={'black'} 
                    />
                </IconWrap>
            </IconContainer>  
        )
    }
    return (
        <FontAwesomeIcon 
            style={{marginRight: '15px'}} 
            size='2x' icon={props.icon} 
            color={'lightgrey'} 
        />        
    )
}

IconNavItem.propTypes = {
    icon: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
};

export default IconNavItem;